import type ExpiresAfter from "domain/ExpiresAfter";
import {expiryLifetimeMinutes} from "home/gating";

/** The completion response has no expiry instant. Anchor the chosen link lifetime once at success. */
export function expiryDeadline(retention: ExpiresAfter, successAtMs: number): number | null {
	const minutes = expiryLifetimeMinutes(retention);
	return minutes === null ? null : successAtMs + minutes * 60_000;
}
